<script setup lang="ts">
import ArrowDown from '@/shared/assets/icons/ArrowDown.svg'
import { cn } from '@/shared/lib/utils'
import { IconImage } from '@/shared/ui'
import { reactiveOmit } from "@vueuse/core"
import type { AccordionTriggerProps } from "reka-ui"
import {
  AccordionHeader,
  AccordionTrigger,
} from "reka-ui"
import type { HTMLAttributes } from "vue"

const props = defineProps<AccordionTriggerProps & {
  class?: HTMLAttributes["class"]
  icon?: unknown
}>()

const delegatedProps = reactiveOmit(props, "class", "icon")
const isIconUrl = (v: unknown): v is string => typeof v === 'string'
</script>

<template>
  <AccordionHeader class="flex">
    <AccordionTrigger
      data-slot="accordion-trigger"
      v-bind="delegatedProps"
      :class="
        cn(
          'property-accordion-trigger w-full flex items-center gap-2 p-2 bg-white-01 rounded-lg border border-[var(--color-gray-02)] outline-none transition-all hover:border-[var(--theme-secondary-ink)] hover:bg-[var(--hover-primary-color)] focus-visible:ring-2 focus-visible:ring-[var(--theme-secondary-ink)] focus-visible:ring-offset-2',
          props.class,
        )
      "
    >
      <div v-if="icon" class="flex-shrink-0 w-6.5 h-6.5 rounded-sm bg-[var(--theme-secondary)] flex items-center justify-center">
        <component :is="icon" class="text-[var(--theme-on-secondary)]" />
      </div>

      <div class="flex-1 text-sm font-medium text-[var(--color-gray-07)] text-left">
        <slot />
      </div>

      <IconImage
        :src="ArrowDown"
        alt="Expandir ou recolher seção"
        class="property-accordion-chevron text-[var(--color-gray-07)] pointer-events-none size-4 shrink-0 transition-transform duration-200"
      />
    </AccordionTrigger>
  </AccordionHeader>
</template>

<style scoped>
.property-accordion-trigger[data-state="open"] .property-accordion-chevron {
  transform: rotate(180deg);
}
</style>
